var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGermanLicensePlateSeals(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 32,
    viewBox: "0 0 19 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.165 6C15.165 9.31371 12.4787 12 9.16497 12C5.85126 12 3.16497 9.31371 3.16497 6C3.16497 2.68629 5.85126 6.55673e-08 9.16497 6.55673e-08C12.4787 6.55673e-08 15.165 2.68629 15.165 6Z",
    fill: "#FFDD1F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.165 6.8H3.16497V5.3H15.165V6.8Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.41497 3.0298V0L9.91497 6.55673e-08V3.0298H8.41497Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.32568 4.7285L4.20436 2.58611L5.26502 1.51491L7.38634 3.6573L6.32568 4.7285Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.9331 3.65724L13.0544 1.51485L14.1151 2.58605L11.9938 4.72844L10.9331 3.65724Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.90431 8.9702L9.90431 12H8.40431L8.40431 8.9702H9.90431Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9936 7.27157L14.1149 9.41396L13.0543 10.4852L10.9329 8.34276L11.9936 7.27157Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.38619 8.34269L5.26487 10.4851L4.20421 9.41389L6.32553 7.2715L7.38619 8.34269Z",
    fill: "black"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1649 23C18.1649 27.9706 14.1355 32 9.16492 32C4.19435 32 0.164917 27.9706 0.164917 23C0.164917 18.0294 4.19435 14 9.16492 14C14.1355 14 18.1649 18.0294 18.1649 23Z",
    fill: "#F4F4F4"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M4.02209 19.1428H14.3078V24.2857C14.3078 27.126 12.0053 29.4285 9.16495 29.4285C6.32463 29.4285 4.02209 27.126 4.02209 24.2857V19.1428Z",
    fill: "#0EB332"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3078 19.1428H9.1649L6.86494 23.7427C5.5588 26.355 7.45836 29.4285 10.3789 29.4285C12.5488 29.4285 14.3077 27.6696 14.3077 25.4998L14.3078 19.1428Z",
    fill: "#D30000"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1649 26.5C11.1649 27.3284 10.4933 28 9.66492 28C8.83649 28 8.16492 27.3284 8.16492 26.5C8.16492 25.6716 8.83649 25 9.66492 25C10.4933 25 11.1649 25.6716 11.1649 26.5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGermanLicensePlateSeals);
export default __webpack_public_path__ + "static/media/german-license-plate-seals.910e4c3b102fe6d45273c5431e29e9fb.svg";
export { ForwardRef as ReactComponent };